<template lang="html">

  <div class="politica-de-privacidad">

    <section class="intro-legales column-center launch">

      <h2 class="subtitle-intro">
        <span>{{$t("vistas.politica_proteccion")}}</span>
      </h2>

    </section> 

    <section class="textos-legales container">
      

        <p>The Direction / Governing Body of  <strong>ALDONZA GOURMET S.A.U.</strong> (hereinafter, the person responsible for the treatment), assumes the maximum responsibility and commitment to the establishment, implementation and maintenance of this Data Protection Policy, guaranteeing the continuous improvement of the data controller. The objective of achieving excellence in relation to compliance with Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and the free circulation of these data and repealing Directive 95/46 / EC (General Data Protection Regulation) (OJEU L 119/1, 04-05-2016), and Spanish legislation on the protection of personal data (Organic Law, specific sector legislation and its development regulations).</p>

<p>The Data Protection Policy of <strong>ALDONZA GOURMET S.A.U.</strong> relies on the principle of proactive responsibility, according to which the controller is responsible for compliance with the regulatory and jurisprudential framework that governs said Policy and is able to demonstrate it to the competent control authorities.</p>

<p>In this sense, the person responsible for the treatment will be governed by the following principles that should serve all its personnel as a guide and frame of reference in the processing of personal data:</p>

<p>1.  <u>Protection of data the design: </u> the controller will apply, both at the time of determining the means of treatment and at the time of the treatment itself, appropriate technical and organizational measures, such as pseudonymization, designed to effectively apply the principles of data protection, such as data minimization, and integrate the necessary guarantees in the treatment.</p>

<p>2.  <u>Protection of data by default: </u> the data controller will apply the appropriate technical and organizational measures in order to guarantee that, by default, only the personal data necessary for each of the specific purposes of the processing will be processed.</p>

<p>3.  <u>Data protection in the information life cycle: </u> the measures that guarantee the protection of personal data will be applicable during the entire life cycle of the information.</p>

<p>4.  <u>Lawfulness, loyalty and transparency: </u> personal data will be treated in a lawful, fair and transparent manner in relation to the interested party. </p>

<p>5.  <u>Limitation of the purpose</u> personal data will be collected for specific, explicit and legitimate purposes, and will not be further processed in a manner incompatible with said purposes.</p>

<p>6.  <u>Minimization of data: </u> personal data will be adequate, relevant and limited to what is necessary in relation to the purposes for which they are treated.</p>
 
<p>7.  <u>Accuracy: </u> personal data will be accurate and, if necessary, all reasonable measures shall be taken so that personal data that are inaccurate with respect to the purposes for which they are treated are d or rectified without delay.</p>

<p>8.  <u>Limitation of the conservation period: </u> the personal data will be maintained in a way that allows the identification of the interested parties during no more time than necessary for the purposes of processing personal data.</p>

<p>9.  <u>Integrity and confidentiality: </u> personal data will be treated in such a way as to ensure adequate security of personal data, including protection against unauthorized or illegal treatment and against loss, destruction or accidental damage, through the application of measures appropriate technical or organizational.</p>

<p>10. <u>Information and training: </u> one of the keys to guarantee the protection of personal data is the training and information provided to the personnel involved in their treatment. During the information life cycle, all personnel with access to data will be properly trained and informed about their obligations in relation to compliance with data protection regulations.</p>

<p>
The Data Protection <strong>Policy of Aldonza Gourmet SAU</strong> is communicated to all the personnel of the data controller and made available to all interested parties.
</p>

<p>As a consequence, this Data Protection Policy involves all the personnel of the data controller, who must know and assume it, considering it as their own, with each member responsible for applying it and verifying the data protection rules applicable to their activity, as well as identifying and contributing the improvement opportunities that it deems appropriate with the objective of achieving excellence in relation to compliance.</p>

<p>This Policy will be reviewed by the Directorate / Governing Body of <strong>Aldonza Gourmet SAU</strong>, as many times as deemed necessary, to adapt, at all times, to the current provisions on the protection of personal data.</p>

    </section>




  </div>
</template>

<script lang="js">
  export default  {
    name: 'politica-de-proteccion-datos',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .politica-de-privacidad {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad-en.vue